import Types from '../../../../actions/Types'
import AppConstants from '../../../../utils/AppConstants'

const initialState = null

export default (state = initialState, action = null) => {
  switch (action.type) {
    case Types.APP.CHANGEPAGE:
      return (
        (
          action.page === AppConstants.PAGE.MAINTENANCE_VIEW
          &&
          action.payload
          &&
          action.payload.id
        )
        ||
        null
      )
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/root/entities/maintenances/view.js